/**
 * Return a keyword to describe a numeric score value. These keywords are not
 * provied by Open Planet, so they had to be added manually and therefore,
 * accuracy is not guaranteed.
 * @param  {String} provider Rating provider; provided by Open Planet
 * @param  {Number} score    Numeric score value; provided by Open Planet
 * @return {String}          Keyword that describes the score
 */
export default function ratingScoreDescription(provider = "", score) {
  if (provider === "bdc") {
    if (parseFloat(score, 10) >= 9.5) return "Exceptional";
    if (parseFloat(score, 10) >= 9) return "Wonderful";
    if (parseFloat(score, 10) >= 8) return "Very good";
    if (parseFloat(score, 10) >= 7) return "Good";
    if (parseFloat(score, 10) >= 6) return "Pleasant";
  }

  if (provider === "hostelworld") {
    if (parseFloat(score, 10) >= 9) return "Superb";
    if (parseFloat(score, 10) >= 8) return "Fabulous";
    if (parseFloat(score, 10) >= 7) return "Very good";
    if (parseFloat(score, 10) >= 6) return "Good";
  }

  return "";
}



// WEBPACK FOOTER //
// ./assets/shared/ratingScoreDescription.js